import { PhoneCall, Sparkles } from "lucide-react";
import PrimaryButton from "../../ui/PrimaryButton";
import SecondaryButton from "../../ui/SecondaryButton";

function CTASection({
  badge = "Counselling CTA",
  title,
  description,
  primaryCta,
  secondaryCta,
  phone,
  secondaryCtaClassName = "border-white/40 bg-white/16 text-white hover:border-white/75 hover:bg-white/25 hover:text-white"
}) {
  return (
    <section className="relative overflow-hidden bg-brand-navy-deep py-24 sm:py-28">
      {/* Animated background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[linear-gradient(135deg,#061630_0%,#0A1F44_35%,#1B3E7A_65%,#D88310_100%)]" />
        <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-brand-gold/8 blur-[120px] animate-float" />
        <div className="absolute -right-20 bottom-0 h-72 w-72 rounded-full bg-brand-navy-soft/30 blur-[100px]" style={{ animationDelay: "3s" }} />
        {/* Subtle grid pattern */}
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)",
            backgroundSize: "60px 60px"
          }}
        />
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-5 sm:px-6 lg:px-10">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold">
            <span className="h-px w-8 bg-brand-gold/70" />
            <Sparkles className="h-3.5 w-3.5" />
            {badge}
          </span>

          <h2 className="mt-7 text-3xl leading-tight text-white sm:text-4xl lg:text-5xl">
            {title}
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white sm:text-lg">
            {description}
          </p>

          {phone ? (
            <a
              href={`tel:${phone.href}`}
              className="mx-auto mt-7 inline-flex items-center gap-2.5 rounded-full border border-white/15 bg-white/8 px-5 py-2.5 text-sm font-bold text-white backdrop-blur-sm transition-all duration-300 hover:border-brand-gold/30 hover:bg-white/12"
            >
              <PhoneCall className="h-4 w-4 text-brand-gold" />
              {phone.label}
            </a>
          ) : null}

          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            {primaryCta ? (
              <PrimaryButton
                showArrow
                to={primaryCta.to}
                href={primaryCta.href}
              >
                {primaryCta.label}
              </PrimaryButton>
            ) : null}
            {secondaryCta ? (
              <SecondaryButton
                className={secondaryCtaClassName}
                to={secondaryCta.to}
                href={secondaryCta.href}
              >
                {secondaryCta.label}
              </SecondaryButton>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
